import React from 'react';
import Theme from '../../../utils/Theme';

const theme = Theme.select({
  redbrand: 'redbrand',
  mands: 'mands',
});

const SvgComponent = (props) => (
  <>
    {theme === 'redbrand' && (
      <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
        <path d="M9 0L1 8v10h7v-6.8h2V18h7V8L9 0zm6.8 16.8h-4.6V10H6.8v6.8H2.2V8.497l6.8-6.8 6.8 6.8V16.8z" />
      </svg>
    )}

    {theme === 'mands' && (
      <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
        <path
          d="M15.41 9.019H9.614V5.793h5.798V9.02zm0 5.752H9.614v-3.195h5.798v3.195zM8.346 9.019H2.549V5.793h5.796V9.02zM4.15 17.995v-6.071c0-.193.156-.349.348-.349h1.892c.193 0 .348.156.348.349v6.071h9.703a.247.247 0 0 0 .238-.22V4.513h1.278V4.26a.578.578 0 0 0-.354-.534l-2.2-.952V.358A.354.354 0 0 0 15.049 0h-.88a.354.354 0 0 0-.354.354v1.729L8.977.009.351 3.723A.581.581 0 0 0 0 4.256v.257h1.278v13.25A.255.255 0 0 0 1.51 18l2.64-.005z"
          fill="#000"
          fillRule="nonzero"
        />
      </svg>
    )}
  </>
);

export default SvgComponent;
